import { Fragment } from 'react';
import TableRowItem from './tableRowItem';
import { makeid } from '../../constants';

interface Props {
  items: any[];
}

const TableBody = ({ items }: Props) => {
  return (
    <Fragment>
      {items.map(item => (
        <TableRowItem
          key={makeid()}
          active={item.isActive}
          items={item}
          rowHeight="62px"
        />
      ))}
    </Fragment>
  );
};

export default TableBody;



// WEBPACK FOOTER //
// ./components/search/tableBody.tsx